export type CoordinatesRequest = {
	address: string;
	key: string;
};

/**
 * https://developers.google.com/maps/documentation/geocoding/requests-geocoding#StatusCodes
 * "OK" indicates that no errors occurred; the address was successfully parsed and at least one geocode was returned.
 * "ZERO_RESULTS" indicates that the geocode was successful but returned no results. This may occur if the geocoder was passed a non-existent address.
 * OVER_DAILY_LIMIT indicates any of the following:
 * The API key is missing or invalid.
 * Billing has not been enabled on your account.
 * A self-imposed usage cap has been exceeded.
 * The provided method of payment is no longer valid (for example, a credit card has expired).
 * See the Maps FAQ to learn how to fix this.
 *
 * "OVER_QUERY_LIMIT" indicates that you are over your quota.
 * "REQUEST_DENIED" indicates that your request was denied.
 * "INVALID_REQUEST" generally indicates that the query (address, components or latlng) is missing.
 * "UNKNOWN_ERROR" indicates that the request could not be processed due to a server error. The request may succeed if you try again.*/

export enum CoordinatesResponseStatus {
	OK = 'OK',
	OVER_DAILY_LIMIT = 'OVER_DAILY_LIMIT',
	ZERO_RESULTS = 'ZERO_RESULTS',
	OVER_QUERY_LIMIT = 'OVER_QUERY_LIMIT',
	REQUEST_DENIED = 'REQUEST_DENIED',
	INVALID_REQUEST = 'INVALID_REQUEST',
	UNKNOWN_ERROR = 'UNKNOWN_ERROR',
}

type AddressComponent = {
	long_name: string;
	short_name: string;
	types: string[];
};
export type LocationType = {
	lat: number;
	lng: number;
};
type ViewPort = {
	northeast?: Location;
	southwest?: Location;
	northwest?: Location;
	southeast?: Location;
};

type LongLocation = {
	latitude: number;
	longitude: number;
};

type NavigationPoint = {
	location: LongLocation;
	road_name: string;
};

export type Result = {
	address_components: AddressComponent[];
	formatted_address: string;
	geometry: {
		location: LocationType;
		location_type: string;
		viewport: ViewPort;
	};
	navigation_points: NavigationPoint[];
	place_id: string;
	types: string[];
};

export type CoordinatesResponse = {
	results: Result[];
	status: CoordinatesResponseStatus;
};

export type CoordinatesViewResponse = {
	addresses: Result[];
	status: CoordinatesResponseStatus;
};
